import { useRef, useState } from "react";

export const useAttendanceConfigSave = (persist: (eventId: number) => Promise<boolean>) => {
  const [pendingEventIds, setPendingEventIds] = useState<number[]>([]);
  const [isSaving, setIsSaving] = useState(false);
  const savingRef = useRef(false);
  const persistRef = useRef(persist);
  persistRef.current = persist;

  const save = async (eventIds: number[]): Promise<boolean> => {
    if (savingRef.current) return false;
    savingRef.current = true;
    setIsSaving(true);
    setPendingEventIds(eventIds);
    const failedIds: number[] = [];
    try {
      for (const eventId of eventIds) {
        try {
          if (!(await persistRef.current(eventId))) failedIds.push(eventId);
        } catch {
          failedIds.push(eventId);
        }
      }
      setPendingEventIds(failedIds);
      return failedIds.length === 0;
    } finally {
      savingRef.current = false;
      setIsSaving(false);
    }
  };

  return { pendingEventIds, isSaving, save };
};
